module.exports = __webpack_public_path__ + "static/img/icon_year.2d163726.png";